import { render, staticRenderFns } from "./ResearcherBanner.vue?vue&type=template&id=e916a768&scoped=true&"
import script from "./ResearcherBanner.vue?vue&type=script&lang=js&"
export * from "./ResearcherBanner.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherBanner.vue?vue&type=style&index=0&id=e916a768&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e916a768",
  null
  
)

export default component.exports